<script setup lang="ts">
import { RouterLink } from "vue-router";
import { computed } from "vue";
import type { VAppLinkProps } from "./VAppLink.types";

const props = defineProps<VAppLinkProps>();
defineOptions({ inheritAttrs: false });

const isExternalLink = computed(
  () => typeof props.to === "string" && props.to.startsWith("http"),
);
</script>

<template>
  <a v-if="disabled" :class="$attrs?.class" @click.prevent>
    <slot />
  </a>
  <template v-else>
    <a
      v-if="isExternalLink"
      v-bind="$attrs"
      :href="to as string"
      :target="target"
      :rel="rel"
    >
      <slot />
    </a>
    <RouterLink
      v-else
      v-slot="{ isActive, href, navigate }"
      v-bind="$props"
      custom
    >
      <a
        v-bind="$attrs"
        :href="href"
        :class="isActive ? activeClass : inactiveClass"
        :target="target"
        :rel="rel"
        @click="navigate"
      >
        <slot />
      </a>
    </RouterLink>
  </template>
</template>
